import api from "../../services/api";
import { initLoading, endLoading, setError } from "../slices/generics.slice";
import moment from "moment";
import { setClassesRequest, setTotalFound, setTotalPages } from "../slices/teacher.slice";
import { logout } from "./user.middleware";

export const getConfirmClass = (teacherId, pageNumber = 1, loading = false) => {
  return async (dispatch, getState) => {
    loading && dispatch(initLoading());

    const { classesRequest } = getState().teacherReducer;

    const params = {
      startAt: moment(new Date()).subtract(30, "minutes").utc().format("YYYY-MM-DDTHH:mm:ss.sss"),
      pageNumber: parseInt(pageNumber),
      pageSize: 10,
    };
    const filterStartDate = "?startAt=" + params.startAt;
    const lang = localStorage.getItem("i18nextLng");

    try {
      const response = await api.get(
        `/classSchedulesNew/teacher/${teacherId}${filterStartDate}&pageNumber=${params.pageNumber}&pageSize=${params.pageSize}&lang=${lang}`,
      );

      const resp = response?.data?.result?.items;
      const resArray = [];
      resArray.push(resp);
      const totalF = response?.data?.result.totalFound;
      let totalP = response?.data?.result.totalPages;
      const groupArray = [];
      for (let a = 0; a < resArray.length; a++) {
        resArray[a].map((el) => {
          groupArray.push(el);
        });
      }
      const uniqueArray = [...new Map(groupArray.map((x) => [x.id, x])).values()];
      if (uniqueArray.length === totalF) {
        totalP = params.pageNumber;
      }
      if (pageNumber > 1) {
        let arrConcat = classesRequest.concat(resp);
        await dispatch(setClassesRequest(arrConcat));
      } else {
        await dispatch(setClassesRequest([]));
        await dispatch(setClassesRequest(resp));
      }
      await dispatch(setTotalPages(totalP));
      await dispatch(setTotalFound(totalF));
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getConfirmClass", error);

      dispatch(setError(error.message));
      loading && dispatch(endLoading());
      return false;
    } finally {
      loading && dispatch(endLoading());
    }
  };
};

export const postConfirmClassRandom = (id, sequentialScheduleId) => {
  return async (dispatch) => {
    dispatch(initLoading());

    const submitObj = {
      teacherId: id,
      sequentialScheduleId: sequentialScheduleId,
    };

    try {
      const res = await api.post(`classSchedules/teacher/${id}/acceptSequentialSchedule`, submitObj);
      return res;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("postConfirmClassRandom", error.response.data);
      dispatch(endLoading());
      throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postConfirmClassFixed = (id, allocationScheduleId) => {
  return async (dispatch) => {
    dispatch(initLoading());

    const submitObj = {
      teacherId: id,
      allocationScheduleId: allocationScheduleId,
    };

    try {
      await api.post(`classSchedules/teacher/${id}/acceptAllocationSchedule`, submitObj);
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("postConfirmClassFixed", error.response.data);
      dispatch(endLoading());
      return error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postAvailabilities = (data) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post(`teacheravailabilities`, data);
      return response.data;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("postAvailabilities", error.response.data);
      dispatch(endLoading());
      return error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const deleteAvailabilities = (data) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.delete(`teacheravailabilities`, data);
      return response.data;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("deleteAvailabilities", error.response.data);
      dispatch(endLoading());
      return error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const refreshCacheTeacher = (teacherId) => {
  return async (dispatch) => {
    dispatch(initLoading());

    const lang = localStorage.getItem("i18nextLng");

    try {
      if (teacherId) {
        await api.post("/refresh-cache-teacher", { teacherId: teacherId, lang: lang });
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("refreshCacheTeacher", error.response.data);
      dispatch(endLoading());
      return error;
    } finally {
      dispatch(endLoading());
    }
  };
};
